/* Reveal-on-scroll. ?static=1 skips it so headless renders capture the page at rest.
   Safety net: anything still hidden after 2.5s is revealed regardless, so a jump-scroll,
   a restored scroll position or a stalled observer can never leave content invisible. */
(function(){
  if(/[?&]static=1/.test(location.search))return;
  var d=document.documentElement; d.classList.add('js');
  var sel='.rev,.revL,.revR,.popin,.stagger,.barfill,.railfill,.drawline,.fadein,.dotpop,.ring,.lfill';
  var els=[].slice.call(document.querySelectorAll(sel));
  var show=function(e){e.classList.add('in')};
  if(!('IntersectionObserver' in window)){els.forEach(show);return;}
  var io=new IntersectionObserver(function(en){
    en.forEach(function(x){if(x.isIntersecting){show(x.target);io.unobserve(x.target);}});
  },{rootMargin:'140px 0px -8% 0px',threshold:0});
  els.forEach(function(e){io.observe(e)});
  /* Safety net, but only for what is already on screen: revealing everything at 2.5s used to kill the scroll
     animation for the whole page below the fold. Below-fold elements keep waiting for the observer. */
  setTimeout(function(){els.forEach(function(e){if(e.getBoundingClientRect().top<innerHeight+140)show(e)})},2500);
  addEventListener('pagehide',function(){els.forEach(show)});
})();

/* Reading progress + the phone-only sticky kit bar. */
(function(){
  if(/[?&]static=1/.test(location.search))return;
  var prog=document.getElementById('prog'), sticky=document.getElementById('sticky'),
      hero=document.querySelector('.pb .hero'), tick=false;
  function upd(){
    tick=false;
    var h=document.documentElement;
    if(prog){var max=h.scrollHeight-h.clientHeight;
      prog.style.transform='scaleX('+(max>0?Math.min(1,h.scrollTop/max):0)+')';}
    if(sticky&&hero) sticky.classList.toggle('on', h.scrollTop > hero.offsetHeight*0.9);
  }
  addEventListener('scroll',function(){if(!tick){tick=true;requestAnimationFrame(upd);}},{passive:true});
  upd();
})();

/* Count the stat tiles up when they land. Handles ranges, commas and non-numeric tiles. */
(function(){
  if(/[?&]static=1/.test(location.search))return;
  if(location.hash==='#capture')return;   // review mode: leave the finals in place, never zero them
  if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  var els=[].slice.call(document.querySelectorAll('.tnum'));
  if(!els.length||!('IntersectionObserver' in window))return;
  els.forEach(function(el){
    var txt=el.textContent, nums=txt.match(/[\d,]+(?:\.\d+)?/g);
    if(!nums)return;
    el.dataset.final=txt;
    var parts=txt.split(/([\d,]+(?:\.\d+)?)/);
    el.textContent=parts.map(function(p){return /[\d,]/.test(p)?'0':p}).join('');
  });
  var io=new IntersectionObserver(function(en){
    en.forEach(function(x){
      if(!x.isIntersecting)return; io.unobserve(x.target);
      var el=x.target, fin=el.dataset.final; if(!fin)return;
      var parts=fin.split(/([\d,]+(?:\.\d+)?)/), t0=performance.now(), D=1100;
      (function step(now){
        var k=Math.min(1,(now-t0)/D), e=1-Math.pow(1-k,3);
        el.textContent=parts.map(function(p){
          if(!/[\d,]/.test(p))return p;
          var target=parseFloat(p.replace(/,/g,''));
          var v=Math.round(target*e);
          return p.indexOf(',')>-1?v.toLocaleString('en-US'):String(v);
        }).join('');
        if(k<1)requestAnimationFrame(step); else el.textContent=fin;
      })(t0);
    });
  },{threshold:.4});
  els.forEach(function(e){if(e.dataset.final)io.observe(e)});
  setTimeout(function(){els.forEach(function(e){
    if(e.dataset.final && /^[\s\d,.\u2013-]*0[\s\d,.\u2013-]*/.test(e.textContent) && e.textContent!==e.dataset.final){
      var r=e.getBoundingClientRect();
      if(r.top>innerHeight) return;            // still below the fold, let the observer do it
      e.textContent=e.dataset.final;
    }});},4000);
})();

/* #capture — review/screenshot mode. Strips overlays that aren't ours, reveals every scroll-animated
   element, hides the fixed bars. Harmless in production: only runs when the URL hash is exactly #capture. */
(function(){
  if(location.hash!=='#capture')return;
  var SEL='[class*="klaviyo-form"],[class*="kl-private"],[id^="kl_"],#shopify-preview-bar,[class*="preview-bar"],iframe[id*="preview-bar"],#preview-bar-iframe,#PBarNextFrameWrapper,#PBarNextFrame,iframe[src*="preview-bar"]';
  var go=function(){
    var pb=document.querySelector('.pb'); if(!pb)return;
    var keep=[]; for(var n=pb;n;n=n.parentElement)keep.push(n);
    Array.prototype.forEach.call(document.body.querySelectorAll('*'),function(el){
      if(keep.indexOf(el)>-1||el.closest('.pb'))return;
      var cs=getComputedStyle(el);
      if(cs.position==='fixed'&&el.getBoundingClientRect().height>innerHeight*0.6)el.remove();});
    Array.prototype.forEach.call(document.body.querySelectorAll(SEL),function(el){
      if(keep.indexOf(el)===-1&&!el.closest('.pb'))el.remove();});
    [document.documentElement,document.body].forEach(function(el){el.style.overflow='auto';});
    Array.prototype.forEach.call(document.querySelectorAll('.rev,.revL,.revR,.popin,.stagger,.barfill,.railfill,.drawline,.fadein,.dotpop,.ring,.lfill'),function(e){e.classList.add('in')});
    Array.prototype.forEach.call(document.querySelectorAll('.tnum'),function(e){if(e.dataset.final)e.textContent=e.dataset.final;});
    ['sticky','prog'].forEach(function(id){var e=document.getElementById(id);if(e)e.style.display='none';});
  };
  go(); setTimeout(go,1200); setTimeout(go,3000);
  /* Late-inserted overlays (Shopify's preview bar lands after our timers): strip body-level additions as they arrive. */
  var strip=function(el){ if(el.nodeType!==1||el.closest('.pb'))return; if(el.matches(SEL)||el.querySelector(SEL)){el.remove();return;}
    var cs=getComputedStyle(el); if(cs.position==='fixed'&&el.getBoundingClientRect().height>innerHeight*0.6)el.remove(); };
  if(window.MutationObserver)new MutationObserver(function(ms){ms.forEach(function(m){Array.prototype.forEach.call(m.addedNodes,strip);});}).observe(document.body,{childList:true});
})();

/* Video loops: reveal only once a frame is actually playing, so the still covers blocked or slow autoplay.
   Offscreen loops are paused by the browser and resume on their own; a failed source removes itself. */
(function(){
  var vs=[].slice.call(document.querySelectorAll('video.heroloop,video.bandloop'));
  vs.forEach(function(v){
    var box=v.closest('.hero,.imgband'); if(!box)return;
    var on=function(){box.classList.add('vidon')};
    if(!v.paused&&v.readyState>2)on();
    v.addEventListener('playing',on);
    v.addEventListener('error',function(){v.remove()},true);
    var s=v.querySelector('source'); if(s)s.addEventListener('error',function(){v.remove()});
    if(v.getBoundingClientRect().top<innerHeight){var p=v.play&&v.play(); if(p&&p.catch)p.catch(function(){});}
  });
})();
